/* eslint-disable react/prop-types */
import React from 'react'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'

export default function ValueCard({ bg, title, value, icon, lightText, hoverableToAdd, onClick }) {
  const { t } = useTranslation()

  return (
    <div
      className={`${styles.card_container} ${lightText ? styles.light : ''} ${hoverableToAdd ? styles.hoverabler : ''}`}
      onClick={onClick}
      style={{ 
        backgroundColor: bg,
        cursor: onClick ? 'pointer' : 'default'
      }}
    >
      <div className={styles.card_icon}>{icon}</div>
      <div className={styles.card_title_info_val}>
        <div className={styles.card_title}>{title}</div>
        <div className={styles.card_value}>{value}</div>
      </div>
      {hoverableToAdd && (
        <button className={styles.add_new_expense}>
          <div className={styles.add_new_expense_icon}>+</div>
          <div className={styles.add_new_expense_text}>{t('ADD_NEW_EXPENDITURE')}</div>
        </button>
      )}
    </div>
  )
}
